import { onAttach } from '../attach';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';
import { UIView, UIViewSpec } from '../view';

export interface UISnapCarouselOptions {
    classes?: UIClassesSpec;
    card_width: number;
    gap: number;
}

export class UISnapCarousel extends UIView {
    constructor(items: UIViewSpec[], options: UISnapCarouselOptions) {
        super('div', ['ui-snapcarousel', options.classes]);

        this.style.setProperty('--ui-card-width', options.card_width + 'px');

        const views: UIViewSpec[] = [...items];

        for(let i = 0; i < 2; i++) {
            for(const p of items) {
                views.push(p.ui_elem.cloneNode(true));
            }
        }

        const scrolled = $el.DIV('r-scrolled', views);

        this.ui_add(scrolled);

        const length = items.length;
        const total_width = options.card_width + options.gap;
        const zero = -total_width * length;

        scrolled.style.setProperty('transform', `translateX(${zero}px)`);
        views[length].classList.add('f-active');

        let refreshing = false;
        let current = 0;

        onAttach(this, () => {
            if(refreshing) return;

            const handle = setInterval(() => {
                if(!this.isConnected) {
                    clearInterval(handle);
                    refreshing = false;
                    return;
                }

                if(current == length - 1)
                    views[current].classList.remove('f-active');
                views[length + current].classList.remove('f-active');
                current = (current + 1) % length;
                const to = zero - current * total_width;
                const from = to + total_width;

                scrolled.style.setProperty('transform', `translateX(${to}px)`);

                setTimeout(() => {
                    if(current == length - 1)
                        views[current].classList.add('f-active');
                    views[length + current].classList.add('f-active');
                }, 250);

                scrolled.animate([
                    { transform: `translateX(${from}px)` },
                    { transform: `translateX(${to}px)` }
                ], { duration: 500 });
            }, 2000);

            refreshing = true;
        });

    }
}
